import { render, staticRenderFns } from "./CbsDatasources.vue?vue&type=template&id=428daf62&scoped=true"
import script from "./CbsDatasources.vue?vue&type=script&lang=js"
export * from "./CbsDatasources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428daf62",
  null
  
)

export default component.exports